import { Route as Home } from "/@/routes/home";

export const App: React.FC = () => {
  return <Home />;
};
